import React, { useEffect, useState} from 'react';
import '../../css/body.css';
import { getCurrentUser, getAppUser } from '../../functions/utils.js'; // Import the utility function

import ImportSelectComponent from'./ImportSelectComponent.js';
import ExactOnlineComponent from'../imports/ExactOnlineComponent.js';
import ExactGlobeComponent from'../imports/ExactGlobeComponent.js';
import ExactGlobeServiceComponent from'../imports/ExactGlobeServiceComponent.js';
import ExactGlobeSelectorComponent from'./ExactGlobeSelectorComponent.js';
import TwinfieldComponent from'../imports/TwinfieldComponent.js';
import MultiversComponent from'../imports/MultiversComponent.js';
import VierPSComponent from'../imports/4psComponent.js';
import SnelStartComponent from'../imports/SnelStartComponent.js';
import EboekhoudenComponent from'../imports/EboekhoudenComponent.js';
import MicrosoftDynamicsComponent from'../imports/MicrosoftDynamicsComponent.js';
import AfasComponent from'../imports/AfasComponent.js';
import XeroComponent from'../imports/XeroComponent.js';
import BestandComponent from'../imports/BestandComponent.js';
import ConnectorComponent from'../utilities/ConnectorComponent.js';
import TestEnvironment from'../utilities/TestEnvironment.js';
import MultiversCallbackComponent from './MultiversCallbackComponent.js';
import UserOverviewComponent from './UserOverviewComponent.js';
function Body() {
  const path = window.location.pathname;
  const queryParams = new URLSearchParams(window.location.search);
  const [currentUser, setCurrentUser] = useState([]);
  const [currentAppUser, setCurrentAppUser] = useState(false);

  useEffect(() =>{
    checkDevUser();
  }, []); 
  useEffect(() =>{
  }, [currentUser, currentAppUser]);

  async function checkDevUser(){
      var currentUser = await getCurrentUser();
      if(currentUser){
        setCurrentUser(currentUser);
        setCurrentAppUser(await getAppUser());
      }
      else{
        setTimeout(function(){
          return checkDevUser();
        }, 500);
      }
  }

  return (
    <div className="App-body"> 
      {!queryParams.get("import") && path == '/app' && <ImportSelectComponent />}
      {path == '/app' && queryParams.get("import") && queryParams.get("import") == 'exactonline' && <ExactOnlineComponent/>}
      {path == '/app' && queryParams.get("import") && queryParams.get("import") == 'exactglobe_db' && <ExactGlobeComponent/>}
      {path == '/app' && queryParams.get("import") && queryParams.get("import") == 'exactglobe_service' && <ExactGlobeServiceComponent/>}
      {path == '/app' && queryParams.get("import") && queryParams.get("import") == 'exactglobe_select' && <ExactGlobeSelectorComponent/>} 
      {path == '/app' && queryParams.get("import") && queryParams.get("import") == 'twinfield' && <TwinfieldComponent/>}  
      {path == '/app' && queryParams.get("import") && queryParams.get("import") == 'snelstart' && <SnelStartComponent/>}   
      {path == '/app' && queryParams.get("import") && queryParams.get("import") == 'afas' && <AfasComponent/>}   
      {path == '/app' && queryParams.get("import") && queryParams.get("import") == 'multivers' && <MultiversComponent/>} 
      {path == '/app' && queryParams.get("import") && queryParams.get("import") == 'xero' && <XeroComponent/>} 
      {currentUser == 819 && path == '/app' && queryParams.get("import") && queryParams.get("import") == 'bestand' && <BestandComponent/>} 
      {path == '/oauth/multivers/callback' && <MultiversCallbackComponent/>}   
      {(currentAppUser.integration_4ps == 1) && path == '/app' && queryParams.get("import") && queryParams.get("import") == '4PS' && <VierPSComponent/>}   
      {currentUser == 819 && path == '/app' && queryParams.get("import") && queryParams.get("import") == 'ebkoekhouden' && <EboekhoudenComponent/>}
      {currentUser == 819 && path == '/app' && queryParams.get("import") && queryParams.get("import") == 'microsoftdynamics' && <MicrosoftDynamicsComponent/>}
      
      {(currentUser == 819 || queryParams.get("developmenttest")) && queryParams.get("import") && queryParams.get("import") == 'appconnector' && <ConnectorComponent/>}   
      {currentUser == 819 && path == '/app/dev/useroverview' && <UserOverviewComponent/>}  
      {(currentUser == 819 || currentUser == 1237) && path == '/app/dev/testenvironment' && <TestEnvironment/>}     
    </div>
  );
}

export default Body;
